export class EksClusterRestoreDestination {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "destinationType",
            "baseName": "destinationType",
            "type": "EksClusterRestoreDestinationType",
            "format": ""
        },
        {
            "name": "destinationClusterName",
            "baseName": "destinationClusterName",
            "type": "string",
            "format": ""
        },
        {
            "name": "namespaces",
            "baseName": "namespaces",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EksClusterRestoreDestination.attributeTypeMap;
    }
    constructor() {
    }
}
